let cache = [];
function findPromiseByConfig(strategy, config) {
    return cache.find((cachedPromise) => 
    // App ID matches
    cachedPromise.config.appMetaData &&
        config.appMetaData &&
        cachedPromise.config.appMetaData.id === config.appMetaData.id &&
        // Environment matches
        config.environment === cachedPromise.config.environment &&
        // Context matches
        config.context === cachedPromise.config.context &&
        // Strategy supports the cached config
        strategy.supports(cachedPromise.config));
}
export const addPromise = (authPromise) => {
    cache.push(authPromise);
};
export const removePromise = (strategy, config) => {
    cache = cache.filter((cachePromise) => cachePromise !== findPromiseByConfig(strategy, config));
};
export const getPromise = (strategy, config) => {
    const cachedPromise = findPromiseByConfig(strategy, config);
    return cachedPromise && cachedPromise.promise;
};
export const clearPromises = () => {
    cache = [];
};
//# sourceMappingURL=authPromiseCache.js.map